import React, { Component } from "react";
import Map from "./Map";
import { insuranceService } from '../services/insurance';

import ProfessionalCard from "./ProfessionalCard";

export class ResultMapView extends Component {

  constructor(props) {
    super(props);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.state = {
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      insurances: []
    };
  }

  get show() {
    return this.props.activeView === "map_view";
  }

  onInfoWindowClose() {
    this.setState({
      showingInfoWindow: false,
      activeMarker: null
    })
  };

  onMarkerClick(props, marker, e) {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }
  componentDidMount(){
    this.getInsurances();
  }

  getInsurances(){
    insuranceService.get()
    .then(
        data => {
          if(data){
            this.setState({
              insurances: data
            });
          }
        },
        error => {
            console.log(error)
        }
    );
  }

  render() {
    if (this.show) {
      return (
        <React.Fragment>
            <div className="map-content">
              <div className="result-list">
                {
                  this.props.results.map((doctor, index) => (
                    <ProfessionalCard key={`doc-card-${index}`} doctor={doctor} onFav={this.props.onFav} insurances={this.state.insurances}/>
                  ))
                }
              </div>
              <div className="map-container">

              <Map results={this.props.results} parentName={`ResultMapView`}/>

              </div>
            </div>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}